import React from "react";
import CustomNavbar from "../CustomNavbar";
import SRVMyWorkAssignments from "./srvMyWorkAssignments";

const SRVMyWorkAssignmentsPage = () => (
  <div className="bg-dark min-vh-100 text-white">
    <CustomNavbar />
    <div className="container mt-4 pb-5">
      <header className="mb-4">
        <h1 className="mb-1">Meine Arbeitseinsätze</h1>
        <p className="text-white-50 mb-0">
          Übersicht deiner anstehenden und vergangenen Einsätze.
        </p>
      </header>
      <SRVMyWorkAssignments />
    </div>
  </div>
);

export default SRVMyWorkAssignmentsPage;
